// extracted by mini-css-extract-plugin
module.exports = {"listItem":"GiftItem_listItem__1vYbm","listItemPurchased":"GiftItem_listItemPurchased__Gn2Ym"};